import {action, computed, observable} from 'mobx';
import SurveyQuestionOption from './SurveyQuestionOption';
import _ from 'lodash';
import {QAQuestion} from '../questions';
import {t} from 'shared/core';

class SurveyQuestion extends QAQuestion {
  @observable name;
  @observable required = true;
  @observable sentimentOptions = [];

  @action merge(other) {
    super.merge(other, {
      sentimentOptions: [SurveyQuestionOption]
    });
  }

  @action validate() {
    if (this.questionType === 'sentiment') {
      const errors = {};

      if (_.uniqBy(this.sentimentOptions, 'title').length !== this.sentimentOptions.length) {
        errors.options = t('errors.qa_question.Options must be unique');
      }
      _.forEach(this.sentimentOptions, option => {
        if (!option.title || _.isEmpty(option.title.trim())) {
          errors.options = t("errors.qa_question.Options can't be blank");
        }
      });

      return errors;
    } else {
      return super.validate();
    }
  }

  @computed get sortedSentimentOptions() {
    return _.orderBy(this.sentimentOptions, 'order');
  }

  @computed get commaSeparatedOptions() {
    return _.chain(this.sortedSentimentOptions)
      .map('title')
      .join(', ')
      .value();
  }
}

export default SurveyQuestion;
